import { apiGet } from "./client.ts";

export interface LedgerEntry {
  id: number;
  delta: number;
  reason: string;
  balanceAfter: number;
  referenceId: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
}

export const creditsApi = {
  balance: () => apiGet<{ balance: number }>("/credits/balance"),

  usage: () => apiGet<{
    plan: string;
    planName: string;
    creditBalance: number;
    videoCredits: number;
    videosThisPeriod: number;
    videosLimit: number;
    videosRemaining: number;
  }>("/credits/usage"),

  ledger: (params: { limit?: number; offset?: number } = {}) => {
    const qs = new URLSearchParams();
    if (params.limit !== undefined) qs.set("limit", String(params.limit));
    if (params.offset !== undefined) qs.set("offset", String(params.offset));
    const q = qs.toString();
    return apiGet<{
      entries: LedgerEntry[];
      pagination: { limit: number; offset: number };
    }>(`/credits/ledger${q ? `?${q}` : ""}`);
  },
};
